<template>
  <div class="menu-item-filials-edit-field">
    <label class="menu-item-filials-edit-field__label">
      <span>Доступность в филиалах</span>
    </label>
    <v-switch
      label="Обязательно для всех филиалов (доступно везде)"
      color="primary"
      :input-value="all"
      @change="updateAllFilialsProp"
    />
    <transition name="slide">
      <div v-show="!all">
        <v-row
          v-for="(item, key) in rows"
          :key="`rp-${key}-${getHash(item)}`"
          class="menu-item-filials-edit-field__row"
        >
          <v-col cols="9">
            <filial-select-with-search-field
              v-model="rows[key]"
              :items="filials"
              :loading="loading"
              :disabled="loading"
              required
              @input="syncValue"
            />
          </v-col>

          <!--          <v-col cols="4">
            <v-text-field
              outlined
              required
              label="Цена"
              v-model="rows[key].options.priceRub"
              placeholder="Цена блюда без изменения"
              :loading="loading"
              :disabled="disabled"
              :rules="rules.number"
              @input="syncValue"
            />
          </v-col>-->
          <v-col cols="1">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="accent"
                  elevation="1"
                  icon
                  small
                  class="mb-2 mt-3"
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(key)"
                >
                  <!-- eslint-disable-next-line -->
                <!--              <v-icon small>mdi-delete</v-icon>-->
                  <font-awesome-icon icon="times" />
                </v-btn>
              </template>
              <span>Удалить</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="menu-item-filials-edit-field__add">
          <v-col cols="3">
            <v-btn
              depressed
              type="button"
              :loading="loading"
              :disabled="disabled"
              block
              color="primary"
              @click.stop="addEmptyItem"
            >
              Добавить
            </v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn
              depressed
              type="button"
              :loading="loading"
              :disabled="disabled"
              block
              color="success"
              @click.stop="addAllFilials"
            >
              Добавить все филиалы
            </v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn
              depressed
              type="button"
              :loading="loading"
              :disabled="disabled"
              block
              color="error"
              @click.stop="deleteAllItems"
            >
              Удалить все
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </transition>
  </div>
</template>

<script>
  import md5 from 'md5'
  import { mapGetters } from 'vuex'
  // import TextField from '@/components/ui/crud/fields/TextField'
  import rules from '@/mixins/rules'
  import FilialSelectWithSearchField from '@/components/ui/crud/fields/FilialSelectWithSearchField.vue'
  import FilialDataService from '@/services/api/FilialDataService'

  export default {
    name: 'MenuItemToFilialsField',
    components: { FilialSelectWithSearchField },
    mixins: [rules],
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      all: {
        type: Boolean,
        default: true,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    data () {
      return {
        rows: [],
        filials: {},
      }
    },
    computed: {
      ...mapGetters({
        // filials: 'branches/getBranches',
      }),
      outputValue () {
        return this.rows.map(item => {
          const output = item.filial
          output.options = {
            priceRub: item.options?.priceRub ? parseInt(item.options?.priceRub) : null,
            price: item.options?.priceRub * 100 || null,
          }
          return output
        })
      },
    },
    watch: {
      value (newValue) {
        this.rows = newValue
        /* this.rows = newValue.map(item => ({
          filial: item,
          options: item.options,
        })) */
      },
    },
    async created () {
      this.filials = await FilialDataService.getAll()
      this.rows = this.value
    },
    methods: {
      getHash (item) {
        return md5(item)
      },
      addEmptyItem () {
        this.rows.push({})
        /*  this.rows.push({
          filial: {},
          options: {
            priceRub: null,
          },
        }) */
      },
      addAllFilials () {
        this.rows = this.filials
        this.syncValue()
      },
      deleteItem (key) {
        this.rows.splice(key, 1)
        this.syncValue()
      },
      deleteAllItems () {
        this.rows = []
        this.syncValue()
      },
      syncValue () {
        this.$emit('input', this.rows)
      },
      updateAllFilialsProp (val) {
        this.$emit('update:all', !!val)
      },
    },
  }
</script>

<style lang="less" scoped>
.menu-item-filials-edit-field {
  padding: 30px;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,0.38);
  position: relative;
  margin-bottom: 50px;

  &__label {
    position: absolute;
    top: 11px;
    left: -12px;
    background: white;
    padding: 0 5px;
    transform: translateY(-24px) scale(0.75);
    color: #999999;
    font-size: 16px;
  }
  &__row {
    padding-top: 5px;
    padding-bottom: 5px;

    ::v-deep {
      .col {
        padding-bottom: 0;
        padding-top: 0;
      }
    }
  }
}
</style>
